'use client'
import { Slot } from '@radix-ui/react-slot'
import { sendEvent } from 'basehub/events'
import { Miscellaneous } from '../../../../basehub-types'

export const EventTracker = ({
  children,
  eventName = 'click',
  ingestKey,
  description,
}: {
  children: React.ReactNode
  eventName?: string
  ingestKey: Miscellaneous['ingestKey']
  description?: string
}) => {
  return (
    <Slot
      onClick={() =>
        sendEvent(ingestKey, {
          eventName,
          description,
        })
      }
    >
      {children}
    </Slot>
  )
}
